/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { PasswordInput } from '../../../components/common';
import FormField, { IFormFieldProps } from './FormField';

const FormFieldInputPassword = (props: IFormFieldProps) => {
    return (
        <FormField {...props}>
            {({ field, kind, disabled, label, dataName, required }) => {
                return (
                    <PasswordInput
                        {...field}
                        dataName={dataName}
                        disabled={disabled}
                        kind={kind}
                        label={label}
                        required={required}
                    />
                );
            }}
        </FormField>
    );
};

export default FormFieldInputPassword;
